import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { EditorService } from '../../services/editor.service';
import { CustomModalService } from '../../shared/as-components/custom-modal/modal.service';
import { InlineEditSliderComponent } from '../inline-edit-slider/inline-edit-slider.component';

@Component({
  selector: 'inline-component-editor',
  standalone: false,
  templateUrl: './inline-component-editor.component.html',
  styleUrl: './inline-component-editor.component.scss',
})
export class InlineComponentEditorComponent {
  @Input({ required: true }) target!: HTMLElement;
  @Input() value!: HTMLElement;
  @Output() closed = new EventEmitter<void>();
  @Output() moved = new EventEmitter<{ element: HTMLElement; dir: string }>();
  @Output() removed = new EventEmitter<HTMLElement>();

  constructor(
    public editorService: EditorService,
    private host: ElementRef<HTMLElement>,
    private modal: CustomModalService
  ) {}

  onClose() {
    this.closed.emit();
    this.editorService.selectTopBar = 'classic';
  }

  onRemove() {
    console.log('usuń element');
    this.editorService.selectTopBar = 'classic';
    if (this.target) {
      this.removed.emit(this.target);
    }
  }

  onMove(dir: 'up' | 'down') {
    console.log('przesuń', dir);
    if (this.target) {
      this.moved.emit({ element: this.target, dir });
    }
  }

  onEdit() {
    this.editorService.selectTopBar = 'slider';
    const dialogRef = this.modal.open(InlineEditSliderComponent, {
      width: '100%',
      height: '100%',
      data: this.value,
      panelClass: 'fullscreen-modal',
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        console.log(result);
      }
    });
  }
}
